import { ListItemButton, Button, Box, styled } from "@mui/material";

export const MoreInfoButtonStyle = styled(Button)(({ theme }) => ({
    fontFamily: "Fixel Display, sans-serif",
    fontWeight: 600,
    fontSize: "16px",
    lineHeight: "24px",
    minWidth: "auto",
    height: "auto",
    padding: "10px 15px 6px 15px",
    background: theme.palette.primary.main,
    color: theme.palette.text.primary,
    border: `1px solid ${theme.palette.text.primary}`,
    borderRadius: "12px",
    textTransform: "none",
    "&:hover": { background: theme.palette.primary.main },
    "&& .MuiTouchRipple-child": { backgroundColor: theme.palette.primary.main },
}));

export const ChronologyBoxStyle = styled(Box)(({ theme }) => ({
    background: theme.palette.primary.dark,
    borderRadius: "8px",

    [theme.breakpoints.only('xl')]: {
        width: "290px",
        height: "216px",
        padding: "16px 8px 0px 16px",
    },
    [theme.breakpoints.only('lg')]: {
        width: "290px",
        height: "216px",
        padding: "16px 8px 0px 16px",
    },
    [theme.breakpoints.only('md')]: {
        width: "215px",
        height: "171px",
        padding: "15px 9px 0px 9px",
    },
    [theme.breakpoints.down('md')]: {
        width: "165px",
        height: "165px",
        padding: "5px 5px 0px 5px",
    },
}));

export const MVBoxStyle = styled(Box)(({ theme }) => ({
    [theme.breakpoints.only('xl')]: {
        width: "640px",
        height: "300px",
        borderRadius: "8px",
    },
    [theme.breakpoints.only('lg')]: {
        width: "640px",
        height: "300px",
        borderRadius: "8px",
    },
    [theme.breakpoints.only('md')]: {
        width: "361px",
        height: "180px",
        borderRadius: "4px",
    },
    [theme.breakpoints.down('md')]: {
        width: "361px",
        height: "180px",
        borderRadius: "4px",
    },

    background: theme.palette.primary.dark,
    border: `1px solid ${theme.palette.text.primary}`,
    position: "relative",
    cursor: "pointer",
    transition: "background 0.4s ease",

    '&:hover': {
        border: `1px solid ${theme.palette.text.primary}`,
        background: "#fff",
    },

    '&:hover h2': {
        color: theme.palette.primary.dark,
    },

    '&:hover h4': {
        color: theme.palette.background.default,
    },

    '&:hover .icon-button': {
        borderColor: theme.palette.primary.dark,
        color: theme.palette.primary.dark,
    },
}));